<template>
    <div class="balance-user">
        <div class="index-view-top">
            <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
            <div class="title">{{ $t("vip.jl") }}</div>
            <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
        </div>
        <div>
            <img :src="img" alt="" style="width:100%;height:100vh" />
        </div>
        <!-- <div class="banner" style="width:100%;height:150px;">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in bannerLists" :key="index">
                    <img :src="baseUrl + item.img" alt="" @click="toLink(item)" style="width: 100%; height: 150px" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="jl">
            <p class="jl1">{{ $t("vip.xrjl") }}</p>
            <p class="jl2" @click="toRules('NEWCOMER_REWARD_DESCRIPTION')">{{ $t("vip.ckgz") }}</p>
        </div>
        <div class="di" style="padding-bottom:10px">
            <img src="../assets/tou1.png" style="width: 43px;height: 43px;" alt="">
            <div class="zhong">
                <div class="shang">
                    <p style="color: #999999;">{{ $t("vip.zcsj") }} </p>
                    <p>+{{ registerAward.USDTAward }}USDT +{{ registerAward.TRXAward }}TRX</p>
                </div>
                <div class="xia">
                    {{ $t("vip.qbsj") }}
                </div>
            </div>

            <div class="anniu dlq" @click="toWalletPhone"
                v-if="registerAward.phoneStatus && registerAward.addressStatus && !registerAward.awardStatus">
                <p>{{ $t("vip.dlq") }}</p>
            </div>
            <div class="anniu" v-else-if="!registerAward.awardStatus" @click="toWalletPhone">
                <p>{{ $t("vip.qwc") }}</p>
            </div>
            <div class="anniu ylq" v-else>
                <p>{{ $t("vip.ylq") }}</p>
            </div>

        </div>
        <div style="width: 100%;height: 6px;background: #060505;"></div>
        <div class="jl">
            <p class="jl1">{{ $t("vip.tgrw") }}</p>
            <p class="jl2" @click="toRules('PROMOTION_MISSION_STATEMENT')">{{ $t("vip.ckgz") }}</p>
        </div>
        <div class="di" v-for="(item, index) in promotionTaskLists" :key="index">
            <img src="../assets/liwu.png" style="width: 43px;height: 43px;" alt="">
            <div class="zhong">
                <div class="shang">
                    <p style="color: #999999;">{{ $t("vip.rwjl") }}</p>
                    <p>+{{ item.rate }}USDT</p>
                    <div>
                        <p>{{ item.version || 0 }}</p>
                        <p>/{{ item.number }}</p>
                    </div>
                </div>
                <div class="xia">
                    {{ $t("vip.yq") }}{{ item.number }}{{ $t("vip.ghy") }}
                </div>
            </div>
            <div @click="toSpread(item)" class="anniu"
                :class="item.status == 'Y' ? 'dlq' : item.status == 'N' ? 'ylq' : 'qwc'">
                <p>{{ item.status == 'Y' ? $t("vip.dlq") : item.status == 'N' ? $t("vip.ylq") : $t("vip.qwc") }}
                </p>
            </div>
        </div> -->
    </div>
</template>

<script>
import { BASEURL } from '@/utils/http'
import { promotionTask, registerAward, receiveRegisterAward, receivePromotionAward, carousel, awardImg } from '@/utils/request'
export default {
    data() {
        return {
            promotionTaskLists: '',//推广任务
            registerAward: '',//新人奖励
            bannerLists: '',
            baseUrl: '',
            img: ''
        };
    },
    mounted() {
        this.baseUrl = BASEURL
        this.contactInfo()
    },
    methods: {
        toRules(item) {
            this.$router.push({
                path: '/rules',
                query: {
                    type: item
                }
            })
        },
        toWalletPhone() {
            if (this.registerAward.phoneStatus == false) {
                this.$router.push("/phone");
            } else if (this.registerAward.addressStatus == false) {
                this.$router.push("/add_address");
            } else {
                if (this.registerAward.awardStatus) {

                } else {
                    receiveRegisterAward().then(res => {
                        if (res.code == '200') {
                            this.$toast.success(this.$t("vip.lqcg"))
                        }
                    })
                }

            }
        },
        //获取推广任务
        contactInfo() {
            awardImg().then(res => {
                if (res.code == '200') {
                    this.img = BASEURL + res.data.img
                }
            })
            carousel({ type: '5' }).then(res => {
                if (res.code == '200') {
                    this.bannerLists = res.data
                }
            })
            setInterval(() => {
                promotionTask().then(res => {
                    if (res.code == '200') {
                        this.promotionTaskLists = res.data
                    }
                })
                registerAward().then(res => {
                    if (res.code == '200') {
                        this.registerAward = res.data
                    }
                })
            }, 2000);
        },
        toSpread(item) {
            if (item.status != 'Y' && item.status != 'N') {
                this.$router.push("/spread");
            } else {
                if (item.status == 'Y') {
                    receivePromotionAward({ level: item.promoteRateId }).then(res => {
                        if (res.code == '200') {
                            this.$toast.success(this.$t("vip.lqcg"))
                        }
                    })
                }
            }
        },
        toBack() {
            this.$router.go("-1");
        },
    },
};
</script>

<style lang="scss" scoped>
.balance-user {
    width: 100vw;
    min-height: 100vh;
    background: #0c0b0b;

    .banner {
        // width: 345px;
        height: 9.375rem;
        border-radius: 0.625rem;
        overflow: hidden;
    }

    .index-view-top {
        height: 3.625rem;
        padding: 0 0.9375rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 1.125rem;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #ffffff;
        }
    }
}

.di {
    display: flex;
    align-items: center;
    padding: 0 0.9375rem 30px;

    .zhong {
        padding-left: 10px;

        .shang {
            display: flex;
            padding-bottom: 6px;
            flex-wrap: wrap;

            >p {
                font-size: 13px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFC400;
                margin-right: 6px;
            }

            >div {
                margin-left: auto;
                display: flex;

                >p:nth-child(1) {
                    font-size: 13px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFC400;
                }

                >p:nth-child(2) {
                    font-size: 13px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #999999;

                }
            }
        }

        .xia {
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
        }
    }
}

.dlq {
    background: linear-gradient(270deg, #FF813E 0%, #FF4748 100%) !important;

    >p {
        color: #FFFFFF !important;
    }
}

.ylq {
    background: #999999 !important;

    >p {
        color: #333333 !important;
    }
}

.anniu {
    width: 68px;
    height: 30px;
    background: #FFC400;
    border-radius: 19px 19px 19px 19px;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    >p {
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #0C0B0B;
    }
}

.jl {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0.9375rem;

    .jl1 {

        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

    .jl2 {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }
}
</style>


// WEBPACK FOOTER //
// src/spread/vip.vue